import React, { Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from '../../container/frontend/layout/header';
import Footer from '../../container/frontend/layout/footer';
import LoadingScreen from "../../container/frontend/loadingScreen";
import CookieConsent from "../../container/frontend/cookieConsent";
import '../../assets/frontend.scss';

const seoByPath = {
  "/": {
    title: "IT Tech European | Web, Mobile, AI & IT Support Services",
    description:
      "IT Tech European delivers modern web and mobile development, AI-powered solutions, UI/UX design, and IT support services for growing businesses across Europe.",
    keywords:
      "IT Tech European, web development Europe, mobile app development, AI solutions, UI UX design, IT support services"
  },
  "/policy": {
    title: "Privacy Policy | IT Tech European",
    description:
      "Read the Privacy Policy of IT Tech European to understand how we collect, use, and protect your data.",
    keywords: "privacy policy, data protection, IT Tech European"
  },
  "/disclaimer": {
    title: "Disclaimer | IT Tech European",
    description:
      "Read the official disclaimer for IT Tech European website content, limitations, and liability terms.",
    keywords: "disclaimer, website terms, IT Tech European"
  },
  "/accessibility": {
    title: "Accessibility | IT Tech European",
    description:
      "Learn about IT Tech European's commitment to website accessibility and inclusive digital experiences.",
    keywords: "accessibility, inclusive design, IT Tech European"
  },
  "/copyright": {
    title: "Copyright Notice | IT Tech European",
    description:
      "Review copyright ownership and permitted usage terms for content published by IT Tech European.",
    keywords: "copyright notice, intellectual property, IT Tech European"
  }
};

function setOrCreateMeta({ name, property, content }) {
  if (!content) return;
  const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    if (name) {
      tag.setAttribute("name", name);
    } else {
      tag.setAttribute("property", property);
    }
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setCanonical(url) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

const FrontLayout = (props) => {
  const location = useLocation();

  useEffect(() => {
    const seo = seoByPath[location.pathname] || seoByPath["/"];
    const baseUrl = "https://www.ittecheuropean.com";
    const canonicalUrl = `${baseUrl}${location.pathname}`;

    document.title = seo.title;
    setCanonical(canonicalUrl);
    setOrCreateMeta({ name: "description", content: seo.description });
    setOrCreateMeta({ name: "keywords", content: seo.keywords });
    setOrCreateMeta({ property: "og:title", content: seo.title });
    setOrCreateMeta({ property: "og:description", content: seo.description });
    setOrCreateMeta({ property: "og:url", content: canonicalUrl });
    setOrCreateMeta({ name: "twitter:title", content: seo.title });
    setOrCreateMeta({ name: "twitter:description", content: seo.description });
  }, [location.pathname]);

  return (
    <div>
      <Header />
      <div>
        <Suspense fallback={<LoadingScreen />}>
          {props.children}
        </Suspense>
      </div>
      <Footer />
      <CookieConsent />
    </div>
  );
};
export default FrontLayout;
